import React, { useState } from "react";
import { Button, Container, ListGroup } from "react-bootstrap";
import { areasTransferApi as api } from "./api/AreasTransfer.api";
import ActivityLoader from "activity/componenets/ActivityLoader";
import DeleteAreaTransfer from "./components/DeleteAreaTransfer";
import AddAreaTransferModal from "./components/AddAreaTransferModal";
import AreaTransferItem from "./components/AreaTransferItem";
import { IAreasTransfers } from "commonFnBcode/types/dmc.types";

const AreaTrasnfersScreen = () => {
  const { data, isFetching } = api.useFetchAreasTransferQuery({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState<any>(null);

  const [copyValue, setCopyValue] = useState<IAreasTransfers | undefined>();

  if (isFetching) return <ActivityLoader />;

  const onCopy = (item: IAreasTransfers) => {
    setCopyValue(item);
    setShowAddModal(true);
  };

  return (
    <Container className="my-5">
      <section className="d-flex justify-content-between align-items-center">
        <h4>Area Transfer List</h4>
        <Button
          className="btn btn-primary btn-flat"
          onClick={() => {
            setCopyValue(undefined);
            setShowAddModal(true);
          }}
        >
          + Add Area Transfer
        </Button>
      </section>

      <ListGroup className="mt-3">
        <AreaTransferItem
          areas={data?.result}
          onCopy={onCopy}
          onDelete={(data) => {
            setShowDeleteModal(true);
            setAreaToDelete(data);
          }}
        />
      </ListGroup>

      <AddAreaTransferModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        defaultValue={copyValue}
      />

      <DeleteAreaTransfer
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        areaTransfer={areaToDelete}
      />
    </Container>
  );
};

export default AreaTrasnfersScreen;
